export enum PdfSettingsHeaderInfoBlocksEnum {
  CUSTOMER = 'CUSTOMER',
  INFO = 'INFO',
  LOGO = 'LOGO',
}
